export const NOTIFICATION_NEW_NOTIFICATION = 'NOTIFICATION_NEW_NOTIFICATION';
export const NOTIFICATION_GET_RECENTS_NOTIFICATIONS =
  'NOTIFICATION_GET_RECENTS_NOTIFICATIONS';
export const NOTIFICATION_UPDATE_STATUS = 'NOTIFICATION_UPDATE_STATUS';
export const NOTIFICATION_REQUEST = 'NOTIFICATION_REQUEST';
export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR';
